import { FhirBundleSdk } from "@metriport/fhir-sdk";
import { getMedicationRows } from "./medication-rows";

export const metadata = {
  tableType: "Medication",
  displayName: "Medications",
  getRows: (bundle: FhirBundleSdk) => getMedicationRows({ bundle }),
};
